import { getAuth, signInWithEmailAndPassword, User } from "firebase/auth";
import cookies from "js-cookie";

export const setToken = (accessToken?: string): string | void => {
  if (!accessToken) {
    return;
  }

  cookies.set("access_token", accessToken, { expires: 365 });

  return accessToken;
};

export const setupAccessToken = async (user: User): Promise<void | string> => {
  const { token: accessToken } = await user.getIdTokenResult(true);

  localStorage.setItem("refresh_token", user.refreshToken);

  return setToken(accessToken);
};

const login = async (email: string, password: string) => {
  const auth = getAuth();

  const result = await signInWithEmailAndPassword(auth, email, password);

  return setupAccessToken(result.user);
};

export default login;

export const getErrorMessage = (firebaseErrorCode: string) => {
  switch (firebaseErrorCode) {
    case "auth/invalid-credential":
      return "Accès invalides";
    case "auth/user-not-found":
      return "Email invalide";
    case "auth/invalid-email":
      return "E-mail invalide";
    case "auth/user-disabled":
      return "Utilisateur désactivé";
    case "auth/wrong-password":
      return "Le mot de passe est incorrect";
    case "auth/too-many-requests":
      return "Ton compte vient d’être bloqué pour des raisons de sécurité, re-tente dans une dizaine de minutes.";
  }
};
